import { type AxiosInstance, isAxiosError } from "axios";

import { makeQueryApiError } from "./libs/factory";
import { isErrorCode, isErrorResponse, isQueryApiError } from "./libs/guards";
import { addApiError } from "./model/api-errors";

const readErrorData = async (data: unknown) => {
  if (!(data instanceof Blob)) {
    return data;
  }
  try {
    return JSON.parse(await data.text());
  } catch {
    return undefined;
  }
};

export const tryConvertErrorResponseIntoQueryApiError = (
  axiosInstance: AxiosInstance,
) => {
  const id = axiosInstance.interceptors.response.use(
    undefined,
    async (error) => {
      if (!isAxiosError(error)) {
        throw makeQueryApiError("UNEXPECTED_ERROR", "ErrInvalidRequest", {});
      }
      const data = await readErrorData(error.response?.data);
      if (!isErrorResponse(data)) {
        throw makeQueryApiError("UNEXPECTED_ERROR", "ErrInvalidRequest", {});
      }
      const { code, customCode, payload } = data;

      if (!isErrorCode(customCode)) {
        throw makeQueryApiError("UNEXPECTED_ERROR", "ErrInvalidRequest", {});
      }

      throw makeQueryApiError(
        code,
        customCode,
        payload as Record<string, unknown> | undefined,
      );
    },
  );

  return () => {
    axiosInstance.interceptors.response.eject(id);
  };
};

export const collectApiErrors = (axiosInstance: AxiosInstance) => {
  const id = axiosInstance.interceptors.response.use(undefined, (error) => {
    if (isQueryApiError(error)) {
      addApiError(error);
    }
    throw error;
  });

  return () => {
    axiosInstance.interceptors.response.eject(id);
  };
};
